import { graphql, useStaticQuery } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const usePrismicFooter = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    fragment FooterFields on PrismicFooterDataType {
      cta {
        headline {
          html
        }
        hyperlink_text
        hyperlink_to {
          url
        }
      }
      company_description {
        html
      }
      sitemap_headline
      socials_headline
      contact_headline
      legal_links {
        text
        to {
          url
        }
      }
      copyright {
        html
      }
      logos {
        image {
          alt
          url
        }
      }
      illustration {
        alt
        url
      }
      awards {
        image {
          alt
          url
          gatsbyImageData
        }
      }
      contact_links {
        link_text
        link_to {
          url
        }
      }
      social_links {
        link_to {
          url
        }
        link_text
      }
    }

    query FooterQuery {
      en: prismicFooter(lang: { eq: "en-us" }) {
        data {
          ...FooterFields
        }
      }

      de: prismicFooter(lang: { eq: "de-de" }) {
        data {
          ...FooterFields
        }
      }
    }
  `);

  return data[locale];
};
